import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { OfflineExportsExportRequestDto, OfflineExportsExportCrmListDto, OfflineExportsCsvListDto, OfflineExportsCrmExportRequestDto } from '../../dto';
import { BaseApiService } from './base-api.service';
import { OfflineExportsCrmExportTypesEnum } from '../../enums';

@Injectable({
    providedIn: 'root'
})
export class OfflineExportsApiService {
    private readonly url: string = 'service/contactcloud/offline-exports';

    constructor(
        private readonly baseApiService: BaseApiService,
    ) { }

    exportCsvWebhooks(webhookId: string, body: OfflineExportsExportRequestDto, jobContactsId?: string) {
      return this.baseApiService.post(`${this.url}/csv/webhooks/${webhookId}`, body, {
          params: jobContactsId ? { jobContactsId } : {}
      });
    }

    exportCsv(body: OfflineExportsExportRequestDto, preview: boolean = false) {
        const previewOrExport: string = preview ? 'preview' : 'export';
        return this.baseApiService.post(`${this.url}/csv/${previewOrExport}`, body);
    }

    getCsvList(): Observable<OfflineExportsCsvListDto[]> {
        return this.baseApiService.get<OfflineExportsCsvListDto[]>(`${this.url}/csv/list`, { showError: true });
    }

    getExportCrmList(): Observable<OfflineExportsExportCrmListDto[]> {
        return this.baseApiService.get<OfflineExportsExportCrmListDto[]>(`${this.url}/export/crm`, { showError: true });
    }

    exportCrm(crmType: OfflineExportsCrmExportTypesEnum, body: OfflineExportsCrmExportRequestDto) {
        return this.baseApiService.post(`${this.url}/export/crm/${crmType}`, body, { showError: true, showSuccess: true })
    }
}
